import React from 'react';
import {View, Platform} from 'react-native';
import Width from '../assets/Width';
import Lottie from "lottie-react";
import {globalImport} from "../common/globalImports";

const LottieComp = ({
  lottieJson,
  width = globalImport.isWeb ?
      137 :
      Platform.OS === 'ios'
    ? Width.width / 3 > 274
      ? 274
      : Width.width / 3
    : 274,
  height = globalImport.isWeb ?
      137 :
      Platform.OS === 'ios'
    ? Width.height / 3 > 274
      ? 274
      : Width.height / 3
    : 274,
}) => {
  return (
    <View
      style={{
        height: height,
        width,
        alignSelf: 'center',
        justifyContent: 'center',
      }}>
      <Lottie animationData={lottieJson()} loop={false} />;
    </View>
  );
};
export default LottieComp;
